import { combineReducers } from 'redux';
import appStateReducer from './AppStateReducer';
import toursReducer from './ToursReducer';

const rootReducer = combineReducers({
  appState: appStateReducer,
  tours:toursReducer
});
export default rootReducer;
